class AdminController {
  constructor(authService, enums) {
    "ngInject";

    this.authService = authService;
    this.enums = enums;

    if(!authService.validateUser(true)) { return; }
  }

}

export default AdminController;



// WEBPACK FOOTER //
// ./client/app/components/admin/admin.controller.js